export const remoteFiltersURLOptionParser = (value: string): number|string => {
  const parsedValue = Number(value)
  if (Number.isNaN(parsedValue)) {
    return value
  }
  return parsedValue
}

export const remoteFiltersURLOptionListParser = (value: string): number[]|string[] => {
  return value.split(',').map(remoteFiltersURLOptionParser) as number[]|string[]
}

export const remoteFiltersURLBooleanParser = (value: string): boolean => {
  let parsedValue
  if (value.toLowerCase() === 'true') {
    parsedValue = true
  } else if (value.toLowerCase() === 'false') {
    parsedValue = false
  } else {
    throw new Error(`Invalid value: ${value}`)
  }
  return parsedValue
}

export const remoteFiltersURLDateParser = (value: string): Date => {
  const re = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/
  const parsedDateValue = new Date(value)
  if (!re.test(value) && isNaN(parsedDateValue.getTime())) {
    throw new Error(`Invalid value: ${value}`)
  }
  return parsedDateValue
}

export const remoteFiltersURLDateRangeParser = (value: string): Date[] => {
  return value.split(',').map(remoteFiltersURLDateParser)
}
